import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import api from '../api';
import Seo from '../components/Seo';
import './Blog.css';

const dataIt = (d) => (d ? new Date(d).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' }) : '');

function Blog() {
  const [articoli, setArticoli] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const carica = async () => {
      try {
        const res = await api.get('/blog');
        setArticoli(res.data.articoli || []);
      } catch (_e) {
        setArticoli([]);
      } finally {
        setLoading(false);
      }
    };
    carica();
  }, []);

  return (
    <div className="blog-page">
      <Seo
        title="Blog — Feste Da Piccoli"
        description="Consigli, idee e ispirazioni per organizzare feste di compleanno per bambini."
        canonical="/blog"
      />
      <div className="blog-header">
        <h1>Blog</h1>
        <p>Idee, consigli e ispirazioni per le feste dei più piccoli.</p>
      </div>

      {loading ? (
        <div className="blog-loading"><div className="spinner" /> Caricamento...</div>
      ) : articoli.length === 0 ? (
        <div className="blog-empty"><p>Non ci sono ancora articoli. Torna presto!</p></div>
      ) : (
        <div className="blog-grid">
          {articoli.map((a) => (
            <Link key={a.id} to={`/blog/${a.slug}`} className="blog-card">
              <div className="blog-card-cover">
                {a.copertina_url ? (
                  <img src={a.copertina_url} alt={a.titolo} loading="lazy" />
                ) : (
                  <div className="blog-card-cover placeholder" />
                )}
              </div>
              <div className="blog-card-body">
                <h2>{a.titolo}</h2>
                {a.estratto && <p className="blog-card-estratto">{a.estratto}</p>}
                <div className="blog-card-meta">
                  {a.pubblicato_at && (
                    <span><Calendar size={14} /> {dataIt(a.pubblicato_at)}</span>
                  )}
                  <span className="blog-card-leggi">Leggi <ArrowRight size={14} /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default Blog;
